function readRoundedFiniteNumber(value) {
  if (value == null) return null;
  if (typeof value === "string" && !value.trim()) return null;

  const numericValue = Number(value);

  return Number.isFinite(numericValue) ? Math.round(numericValue) : null;
}

export function pickHeartDxHrBpm(data) {
  const value =
    data?.heartdx?.hr ?? data?.results?.heartdx?.data?.hr ?? data?.hr ?? null;

  return readRoundedFiniteNumber(value);
}

export function pickHeartDxHRV(data) {
  const value =
    data?.heartdx?.hrv?.SDNN ??
    data?.results?.heartdx?.data?.hrv?.SDNN ??
    data?.hrv?.SDNN ??
    null;

  return readRoundedFiniteNumber(value);
}
